import {useEffect} from "react"
import {HISTORY_EVENT} from "../../config/constants"
import {getWindow} from "../../utils/window"
import isSafari from "../../utils/isSafari"

// Safari fires a popstate event when using the back button to return to a cached PLP page.
// if the navigation is type 2 (back/forward), ignore the first popstate.
let navigateBack = false

export const useUrlListener = (loadPageFromUrl: (url: string) => void) => {
    useEffect(() => {
        const win = getWindow() as any
        const {userAgent} = win.navigator
        const isSafariUa = isSafari({userAgent})

        const onPageLoad = () => {
            navigateBack = true
            win.history.replaceState({type: HISTORY_EVENT}, "", win.location.toString())
        }

        win.addEventListener("load", onPageLoad)

        const onPageShow = () => {
            // navigation.type 2 == back/forward
            const {type} = win.performance.navigation
            if (isSafariUa && type === 2) {
                navigateBack = false
            }
        }

        win.addEventListener("pageshow", onPageShow)

        if (!isSafariUa) {
            navigateBack = true
        }

        const handleUrlChange = (event: PopStateEvent) => {
            if (!navigateBack) {
                navigateBack = true
                return
            }

            if (event.state && event.state.type === HISTORY_EVENT) {
                loadPageFromUrl((getWindow() as any).location.toString())
            } else {
                ;(getWindow() as any).history.go(-1)
            }
        }
        ;(getWindow() as any).addEventListener("popstate", handleUrlChange)

        return () => {
            ;(getWindow() as any).removeEventListener("popstate", handleUrlChange)
        }
    }, [loadPageFromUrl])
}
